/**
 * Session History Redux Async Thunks
 * Handles asynchronous API calls with Redux Toolkit
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { sessionHistoryService } from '../../services/sessionHistory';
import {
  ISessionHistoryFilters,
  ISessionHistoryResponse,
} from '../../interface/sessionHistoryModel';
import { showNotification } from '../slices/notification.slice';

/**
 * Fetch session history with filters and pagination
 * API response includes organization-wide summary metrics
 */
export const fetchSessionHistory = createAsyncThunk<
  ISessionHistoryResponse,
  ISessionHistoryFilters,
  { rejectValue: string }
>('sessionHistory/fetchSessionHistory', async (filters, { rejectWithValue, dispatch }) => {
  try {
    const response = await sessionHistoryService.getSessionHistory(filters);
    return response;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || i18n.t('toast.network_error_loading_sessions', 'Network error loading sessions');

    dispatch(
      showNotification({
        message: errorMessage,
        severity: 'error',
        life: 5000,
      }),
    );

    return rejectWithValue(errorMessage);
  }
});
